<template>
    <div class="form-group col-md-6">
        <label for="input_address" class="mb-0"> {{ $t('address') }} </label>
        <app-input 
            id="input_address" 
            class="form-control" 
            type="text" 
            v-model="selected"
            :placeholder="$t('input_address')" />
    </div>
</template>

<script>
    export default {
        name: 'addressAddress',
        props: {
            value: {
                type: [String, Number, Object],
                default: null
            },
        },
        computed: {
            selected: {
                get() {
                    return this.value;
                },
                set(newValue) {
                    this.$emit('input', newValue);
                }
            }
        }
    }
</script>
